import React from "react";
import { MARQUEE_TEXT } from "../mock/mock";

export default function Marquee({ dark = false }) {
  const chunk = MARQUEE_TEXT.repeat(8);
  return (
    <div
      className={`overflow-hidden marquee-mask border-y ${
        dark ? "border-white/10 bg-black" : "border-neon/30 bg-neon"
      } py-3`}
    >
      <div className="flex w-max animate-marquee">
        {[0, 1].map((i) => (
          <span
            key={i}
            className={`font-display text-lg md:text-2xl tracking-wide whitespace-nowrap ${
              dark ? "text-white/90" : "text-black"
            }`}
          >
            {chunk}
          </span>
        ))}
      </div>
    </div>
  );
}
